import { Injectable } from '@angular/core'

@Injectable()
export class DocumentWrapper extends Document {
}